import { useLanguageStore } from '../stores/use-language'
import { useConfigWatchEffect } from './use-config-watch-effect'

export const useChangeLanguage = (
  callback: (data?: { oldLang: string | undefined; newLang: string }, loadMore?: boolean) => Promise<any>,
  options: { immediate?: boolean } = { immediate: true },
) => {
  const languageStore = useLanguageStore()

  const autoRun = async () => {
    return new Promise<void>((resolve) => {
      watch(
        () => languageStore.currentLanguage,
        async (newLang, oldLang) => {
          await callback({
            oldLang,
            newLang,
          })
          resolve()
        },
        options,
      )
    })
  }

  onBeforeMount(() => {
    useConfigWatchEffect(autoRun)
  })
}
